import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { Select as SENDER_SELECT } from 'Components/Api/LevinDMTAPI';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Hidden } from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MONEY_TRANSFER_CODE } from 'Components/Helper/Messages';
import BeneficiaryList from './BeneficiaryList';
import { Last10Report } from 'Pages/InnerPages/Report/Last10Report';

import { PrimaryButton } from 'Components/Inputes/CustomButton';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import AddbeneficiaryIcon from 'Components/SvgButtons/AddbeneficiaryIcon';

import HOCLoader from 'Components/Loader/HOCLoader';
import AutoSubmitMobileForSender from 'Components/Helper/AutoSubmitMobileForSender';
import { useLocation } from 'react-router-dom';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';

const CustomContainer = HOCLoader(Container);

export const SenderSearch = () => {
    const formRef = useRef();
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [addBeneficiary, setAddBeneficiary] = useState('none');
    const [serviceCode, setServiceCode] = useState(MONEY_TRANSFER_CODE);

    const Mobile = location?.state?.Mobile;
    const [senderNo, setSenderNo] = useState('');
    const ActiveDMTName = location?.state?.DMTName;

    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        SenderID: '',
        RemainingLimit: '',
        LastName: '',
        isAddBeneficiary: false
    });

    useEffect(() => {
        fetchConsumerNumberFontSize();
    }, []);

    useEffect(() => {
        select();
        setLoading(false);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (formRef === undefined) return;

            if (!formRef.current) return;

            if (formRef.current.values === undefined) return;

            if (formRef.current.values.Mobile === undefined) return;

            if (formRef.current.values.Mobile.length !== 10) return;

            formRef.current.handleSubmit();
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    const select = async () => {
        let primaryID = Mobile;
        if (primaryID === undefined) return;
        if (primaryID === null) return;
        if (primaryID === 'DMT') return;

        if (primaryID.length !== 10) return;

        let ActiveDMT = ActiveDMTName;
        if (ActiveDMT === undefined) return;
        if (ActiveDMT === null) return;
        if (ActiveDMT === '') return;

        setFormObject({
            ...formObject,
            Mobile: primaryID,
            Name: '',
            SenderID: '',
            RemainingLimit: ''
        });
    };

    const submitHandle = async (values, { setSubmitting, resetForm }) => {
        setResponseMessage('');

        setServiceCode('');
        setSenderNo('');

        values.DMTName = ActiveDMTName;

        var requestObj = JSON.stringify(values);

        setLoading(true);
        setIsError(false);

        if (values.isAddBeneficiary) {
            var param = {
                Mobile: values.Mobile,
                SenderID: values.SenderID,
                SenderName: values.Name,
                DMTName: ActiveDMTName
            };
            history.push('/LF_BeneAdd', param);
            return;
        }

        setFormObject({
            ...formObject,
            Mobile: values.Mobile,
            Name: '',
            LastName: '',
            SenderID: '',
            RemainingLimit: ''
        });
        var response = await SENDER_SELECT(requestObj);

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        setServiceCode(MONEY_TRANSFER_CODE);
        setSeverity('success');

        var param_2 = {
            Mobile: values.Mobile,
            DMTName: ActiveDMTName
        };

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);

            if (response.data === 'User not exists!') {
                history.push('/LF_SenderAdd', param_2);
                return;
            }
            if (
                response.data ===
                'Your KYC is not approved, please contact to customer care'
            ) {
                history.push('/KycIndex');
                return;
            }
            setLoading(false);
            return;
        }
        setAddBeneficiary('inline');
        var data = JSON.parse(response.data);

        setFormObject({
            Mobile: values.Mobile,
            SenderID: values.Mobile,
            Name: data.Name,
            LastName: data.LastName,
            RemainingLimit: data.RemainingLimit,
            isAddBeneficiary: false,
            DMTName: ActiveDMTName
        });
        setSenderNo(values.Mobile);
    };

    const FormValidationSchema = Yup.object({});

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <AutoSubmitMobileForSender />
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialNumberField
                                                font_size={
                                                    consumerNumberFontSize
                                                }
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                typed_length={1}
                                                placeholder="Mobile"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                title="Search"
                                                disabled={loading}
                                                endIcon={<SearchIcon />}
                                                onClick={(e) => {
                                                    setFieldValue(
                                                        'isAddBeneficiary',
                                                        false
                                                    );
                                                    setAddBeneficiary('none');
                                                    handleSubmit(e);
                                                }}
                                            >
                                                Search
                                            </PrimaryButton>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Box display={addBeneficiary}>
                                                <PrimaryButton
                                                    title="Add Beneficiary"
                                                    disabled={loading}
                                                    endIcon={
                                                        <AddbeneficiaryIcon />
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddBeneficiary',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add Beneficiary
                                                </PrimaryButton>
                                            </Box>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="FirstName"
                                                name="Name"
                                                type="text"
                                                readOnly={true}
                                                placeholder="FirstName"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="LastName"
                                                name="LastName"
                                                type="text"
                                                readOnly={true}
                                                placeholder="LastName"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Remaining Limit"
                                                name="RemainingLimit"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Remaining Limit"
                                            />
                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="SenderID"
                                                    name="SenderID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="SenderID"
                                                />
                                            </Hidden>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <BeneficiaryList
                senderNo={senderNo}
                ActiveDMTName={ActiveDMTName}
                senderName={formObject.Name}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />

            <Last10Report
                ServiceID={serviceCode}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />
        </CustomContainer>
    );
};
